'use strict';

var _ = require('lodash');
var RomSummaryChartsTooltipService = function RomSummaryChartsTooltipService($filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var rmNumberFormat = $filter('rmNumberFormat');
  var tooltipTemplate = _.template(require('../templates/rom-summary-charts-tooltip.html'));
  var types = ['OPPORTUNITY_TREND', 'MIN_ACT_MAX_REVENUE', 'DMND_PAX', 'AVG_FARE', 'DMND_WEIGHT'];
  var resTypeAbbreviation = {
    'Individual': 'Idv',
    'Group': 'Grp'
  };
  function getFormatters(chart, title, view) {
    var formatters = {};
    _.forEach(types, function (type) {
      var formatter = getTooltip(type, title);
      formatter.cssClass = 'rom-summary-tooltip ' + _.kebabCase(view) + '-' + _.kebabCase(chart) + '-chart-tooltip';
      formatters[type] = _.assign(getBaseFormatter(chart), {
        tooltipFormatter: formatter
      });
    });
    return formatters;
  }
  function getBaseFormatter(chart) {
    var bases = {
      DATE_RANGE: {
        yAxisTickFormatter: function yAxisTickFormatter(d) {
          return rmNumberFormat(d, 'NUMBER_SHORT');
        },
        xAxisTickFormatter: function xAxisTickFormatter(d) {
          return rmMomentFormat(d, 'MONTH_DAY');
        },
        xYearAxisTickFormatter: function xYearAxisTickFormatter(d) {
          return rmMomentFormat(d, 'YEAR');
        },
        yRightAxisTickFormatter: function yRightAxisTickFormatter(d) {
          return rmNumberFormat(d, 'PERCENTAGE');
        }
      },
      DAY_OF_WEEK: {
        yAxisTickFormatter: function yAxisTickFormatter(d) {
          return rmNumberFormat(d, 'NUMBER_SHORT');
        },
        xAxisTickFormatter: function xAxisTickFormatter(d) {
          return d.slice(0, 3);
        },
        yRightAxisTickFormatter: function yRightAxisTickFormatter(d) {
          return rmNumberFormat(d, 'PERCENTAGE');
        }
      },
      RES_TYPE: {
        yAxisTickFormatter: function yAxisTickFormatter(d) {
          return rmNumberFormat(d, 'NUMBER_SHORT');
        },
        xAxisTickFormatter: function xAxisTickFormatter(d) {
          return resTypeAbbreviation[d];
        },
        yRightAxisTickFormatter: function yRightAxisTickFormatter(d) {
          return rmNumberFormat(d, 'PERCENTAGE');
        }
      },
      DEFAULT: {
        yAxisTickFormatter: function yAxisTickFormatter(d) {
          return rmNumberFormat(d, 'NUMBER_SHORT');
        },
        xAxisTickFormatter: function xAxisTickFormatter(d) {
          return d;
        },
        yRightAxisTickFormatter: function yRightAxisTickFormatter(d) {
          return rmNumberFormat(d, 'PERCENTAGE');
        }
      }
    };
    return bases[chart] || bases.DEFAULT;
  }
  function getMetrics(data, pattern) {
    var metrics = [];
    pattern.map(function (metric) {
      var circle = _.find(data.circles, {
        css: metric.css
      });
      if (circle !== undefined) {
        metric.value = circle.value;
        metrics.push(metric);
      }
    });
    return metrics;
  }
  function getTooltip(view, title) {
    var tooltips = {
      OPPORTUNITY_TREND: function OPPORTUNITY_TREND(d) {
        return tooltipTemplate({
          header: d.stackLabel,
          abbreviation: title.split(' ').map(function (word) {
            return word[0].toUpperCase();
          }).join(''),
          metrics: [{
            label: 'Spill Rev Gap',
            value: d.spill
          }, {
            label: 'Recap Rev Gap',
            value: d.recapture
          }, {
            label: 'Rev Opp.',
            value: d.revOpp,
            suffix: '%',
            lineLegend: true
          }]
        });
      },
      MIN_ACT_MAX_REVENUE: function MIN_ACT_MAX_REVENUE(d) {
        var metrics = [{
          label: 'Max Revenue',
          css: 'curve-max-revenue',
          lineLegend: true
        }, {
          label: 'Actual Revenue',
          css: 'curve-act-revenue',
          lineLegend: true
        }, {
          label: 'Min Revenue',
          css: 'curve-min-revenue',
          lineLegend: true
        }];
        return tooltipTemplate({
          header: rmMomentFormat(d.dimension, 'DATE_USER_SETTINGS'),
          abbreviation: title.split(' ').map(function (word) {
            return word[0].toUpperCase();
          }).join(''),
          metrics: getMetrics(d, metrics)
        });
      },
      DMND_PAX: function DMND_PAX(d) {
        var metrics = [{
          label: 'Act Pax',
          css: 'curve-act-pax',
          lineLegend: true
        }, {
          label: 'Opt Pax',
          css: 'curve-opt-pax',
          lineLegend: true
        }, {
          label: 'Demand',
          css: 'curve-demand',
          lineLegend: true
        }];
        return tooltipTemplate({
          header: rmMomentFormat(d.dimension, 'DATE_USER_SETTINGS'),
          abbreviation: title.split(' ').map(function (word) {
            return word[0].toUpperCase();
          }).join(''),
          metrics: getMetrics(d, metrics)
        });
      },
      AVG_FARE: function AVG_FARE(d) {
        var metrics = [{
          label: 'Avg Fare Act',
          css: 'curve-fare-act',
          lineLegend: true
        }, {
          label: 'Avg Fare Opt',
          css: 'curve-fare-opt',
          lineLegend: true
        }];
        return tooltipTemplate({
          header: rmMomentFormat(d.dimension, 'DATE_USER_SETTINGS'),
          abbreviation: title.split(' ').map(function (word) {
            return word[0].toUpperCase();
          }).join(''),
          metrics: getMetrics(d, metrics)
        });
      },
      DMND_WEIGHT: function DMND_WEIGHT(d) {
        var metrics = [{
          label: 'Act Open',
          css: 'curve-act-open',
          suffix: '%',
          lineLegend: true
        }, {
          label: 'Opt Open',
          css: 'curve-opt-open',
          suffix: '%',
          lineLegend: true
        }];
        return tooltipTemplate({
          header: rmMomentFormat(d.dimension, 'DATE_USER_SETTINGS'),
          abbreviation: title.split(' ').map(function (word) {
            return word[0].toUpperCase();
          }).join(''),
          metrics: getMetrics(d, metrics)
        });
      }
    };
    return tooltips[view] || false;
  }
  return {
    getFormatters: getFormatters
  };
};
RomSummaryChartsTooltipService.$inject = ['$filter'];
module.exports = RomSummaryChartsTooltipService;